const alertsConstants = {
  SHOW_SUCCESS_ALERT: 'SHOW_SUCCESS_ALERT',
  SHOW_INFO_ALERT: 'SHOW_INFO_ALERT',
  SHOW_ERROR_ALERT: 'SHOW_ERROR_ALERT',
  CLEAR_ALERT: 'CLEAR_ALERT',
};

export default alertsConstants;
